/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Credentials/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Email from './Email/index'
import Password from './Password/index'
import React from 'react'
import ResetPasswordAction from './ResetPasswordAction/index'
import SignInAction from './SignInAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Credentials({
  children,
  viewPath = "/App/Auth/SignIn/Credentials"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<Email
  viewPath={`${viewPath}/Email`}
/>
<Password
  viewPath={`${viewPath}/Password`}
/>
<div
  data-testid="Credentials.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2jk64N': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<ResetPasswordAction
  viewPath={`${viewPath}/ResetPasswordAction`}
/>
<SignInAction
  viewPath={`${viewPath}/SignInAction`}
/>
</div>
{children}
</React.Fragment>)
}